export const selectDictionary = ({ dictionary }) => dictionary;
